export function calendar() {
  if ($('#datepicker').length) {

    //▼3日後
    var dt = new Date();
    dt.setDate(dt.getDate() + 3);

    $('#datepicker')
      .datepicker({
        showOn: 'button',
        // buttonText: "",
        buttonImageOnly: true, // ボタンに画像だけ表示したいとき
        buttonImage: '../assets/images/ico_calendar.svg',
        showButtonPanel: true,
        minDate: dt,          //開始日時
        maxDate: "+2m",       //終了日時
        onSelect: function (date) { 
          $('#datepicker').blur();
         }, 
      })
      .holiday();
  }

}
